'use client';

import { UIComponent } from '@/components/core/components';
import { Trans } from '@lingui/react/macro';
import { Button, Image } from '@/components/core';
import { useDownloadApp } from '@/components/core/components/organism/download-app-modal/download-app-modal';
import * as styles from './brands.styles';

const Brands: UIComponent = () => {
  const openDownloadApp = useDownloadApp();

  return (
    <section className={styles.root}>
      <div className={styles.content}>
        <h3 className={styles.title}>
          <Trans>Do you want to expand your business?</Trans>
        </h3>
        <p>
          <Trans>Strengthen your reputation</Trans>
        </p>
        <Button
          className={styles.button}
          variant="secondary"
          onClick={() => {
            openDownloadApp('default');
          }}
        >
          <Trans>Start</Trans>
        </Button>
      </div>
      <div className={styles.image}>
        <Image src="/home-banner-brands.png" alt="Home Banner Brands" />
      </div>
    </section>
  );
};

export default Brands;
